import { render, staticRenderFns } from "./customer-types.vue?vue&type=template&id=55809a05&scoped=true&"
import script from "./customer-types.vue?vue&type=script&lang=js&"
export * from "./customer-types.vue?vue&type=script&lang=js&"
import style0 from "./customer-types.vue?vue&type=style&index=0&id=55809a05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55809a05",
  null
  
)

export default component.exports